var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7.125 8.07744C7.12246 8.04973 7.12121 8.02165 7.12131 7.99326C7.12299 7.50797 7.51775 7.11593 8.00304 7.11761C8.18956 7.11825 8.37196 7.07936 8.53969 7.0029C8.6795 6.93917 8.80853 6.84968 8.92285 6.73535C9.43253 6.22568 9.43253 5.39932 8.92285 4.88965C8.67191 4.6387 8.34629 4.50643 8.00245 4.50739C7.65686 4.50836 7.32348 4.64331 7.07715 4.88965C6.82036 5.14643 6.69158 5.46213 6.69495 5.80384C6.69973 6.28911 6.31023 6.68637 5.82496 6.69115C5.33969 6.69593 4.94243 6.30643 4.93765 5.82116C4.92963 5.00767 5.24368 4.2378 5.83449 3.64699C6.4135 3.06797 7.19339 2.75225 7.99755 2.75001C8.80577 2.74776 9.58132 3.06279 10.1655 3.64699C11.3615 4.84297 11.3615 6.78203 10.1655 7.97801C9.90256 8.24097 9.59952 8.45115 9.26861 8.60199C9.1201 8.66969 8.96694 8.72498 8.81057 8.76767C8.68026 9.08725 8.36643 9.3125 8 9.3125C7.51675 9.3125 7.125 8.92075 7.125 8.4375V8.07744ZM6.6875 11.9375C6.6875 12.6624 7.27513 13.25 8 13.25C8.72487 13.25 9.3125 12.6624 9.3125 11.9375C9.3125 11.2126 8.72487 10.625 8 10.625C7.27513 10.625 6.6875 11.2126 6.6875 11.9375Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.e6944704c9d00d7e82a35fbb33d41eed.svg";
export { ForwardRef as ReactComponent };